






















import { Component, Vue } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { InteractionModel } from '@/app/shared/models';
import DialogCustomer from '@/app/shared/components/dialogs/customer.vue';
import ContentCustomerBilling from '@/app/shared/components/contents/customer-billing.vue';
import ContentCustomerInsurance from '@/app/shared/components/contents/customer-insurance.vue';
@Component({
  components: {
    DialogCustomer,
    ContentCustomerBilling,
    ContentCustomerInsurance,
  },
})
export default class PanelCustomerComponent extends Vue {
  private show = false;

  private get refs() {
    return refsService;
  }

  private async openContent() {
    this.show = !this.show;
    if (this.show && !this.refs.modules.ticket.consultPersonalData) {
      this.refs.modules.ticket.SET_CONSULT_PERSONAL_DATA(true);
      this.refs.modules.ticket.createInteraction(
        new InteractionModel(
          this.$t('action_code.ac0'),
          this.$t('action_desc.ad1')
        )
      );
    }
  }
}
